module.exports = __webpack_public_path__ + "media/images/OPL EXPRESS 2-a484472f3111d26d68ccb8d9365f2d3a.png";